<template>
  <div class="voice-room" ref="voiceRoomBox" id="voice-room">
    <div class="right">
      <div class="main" ref="voiceRoomMain">
        <voice-room-main class="voice-room-main"></voice-room-main>
        <chat-vue class="chat-main"></chat-vue>
        <div class="rank-main">
          <rank-vue :roomUid="roomUid"></rank-vue>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import VoiceRoomMain from '@/components/VoiceRoom/component/voice-room-main.vue';
import ChatVue from '@/components/VoiceRoom/component/chat.vue';
// import UserList from '@/components/VoiceRoom/component/user-list.vue';
import RankVue from '@/components/VoiceRoom/component/rank/index.vue';
import mRtc from '@/components/VoiceRoom/mRtc';
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
import ChatProvider from '@/components/VoiceRoom/chatProvider';
import SeatProvider from '@/components/VoiceRoom/seatProvider';
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';
import { getToken, getRoomInfo, joinRoom, keepConnect } from '@/api/voice-room';
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
export default {
  name: 'VoiceRoom',
  components: {
    VoiceRoomMain,
    ChatVue,
    // UserList,
    RankVue
  },
  props: {},
  data() {
    return {
      VoiceRoomProvider,
      SeatProvider,
      ChatProvider,
      CurrentUserProvider,
      VoiceRoomIM,
      mRtc,
      localVoiceRoomId: localStorage.getItem('voiceRoomId'),
      keepConnectLoading: false,
      keepConnectInterval: null,
      scale: 0
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path != '/') {
      window.open(to.fullPath, '_blank');
      next(false);
    } else {
      next(true);
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['userInfo', 'aliasList']),
    roomUid() {
      const { roomUid } = this.$route.params;
      if (this.aliasList && this.aliasList.length) {
        const aliaItem = this.aliasList.find(item => {
          return item.userUuid == roomUid || item.alias == roomUid;
        });
        return aliaItem ? aliaItem.userUuid : roomUid;
      } else {
        return roomUid;
      }
    },
    uuid() {
      return this.userInfo.uuid ? Number(this.userInfo.uuid) : null;
    },
    roomInfo() {
      return VoiceRoomProvider.roomInfo;
    },
    // 麦位
    seatList() {
      return SeatProvider.list;
    }
  },
  methods: {
    async initData() {
      if (!this.aliasList) {
        await this.$store.dispatch('app/setAliasList');
        console.log('aliasList', this.aliasList);
      }
      localStorage.setItem('voiceRoomId', '');
      this.localVoiceRoomId = this.roomUid;
      // 在一个标签页中
      window.onstorage = e => {
        console.log(e);
        if (e.key === 'voiceRoomId' && e.newValue !== this.localVoiceRoomId) {
          this.$router.replace('/');
        }
      };
      localStorage.setItem('voiceRoomId', this.roomUid);
      VoiceRoomEventEmitter.on(VoiceRoomEvent.OnAdminChange, () => {
        this.getUserAdmin();
      });
      VoiceRoomEventEmitter.on(VoiceRoomEvent.onKickedOutRoom, () => {
        this.$confirm({
          content: '你已被加入小黑屋，去其他厅玩吧',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: false
        }).then(() => {
          this.$router.push({ path: '/' });
        });
      });
      VoiceRoomEventEmitter.on(VoiceRoomEvent.voiceRoomScale, scale => {
        this.scale = scale || 0;
        console.log('VoiceRoomEvent.voiceRoomScale', this.scale);
        this.setScale();
      });
      this.init();
      window.onresize = () => {
        this.setScale();
      };
    },
    /**
     * @description: 加入群聊
     * @return {*}
     */
    async joinGroup() {
      try {
        await VoiceRoomIM.joinGroup(this.roomUid);
      } catch (error) {
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomUid, fun: 'joinGroup' },
          error
        );
      }
    },

    async init() {
      try {
        await CurrentUserProvider.setUserInfo(this.userInfo);
        await this.getUserAdmin();
        ChatProvider.init();
        SeatProvider.init(this.roomUid);
        await this.getRoomInfo();
        await this.initRtc();
        await this.initIm();
        SeatProvider.getSeatList();
        // VoiceRoomIM.getGroupMemberProfile();
        SeatProvider.init(this.roomUid);

        this.joinRoom();
        this.keepConnect();
      } catch (error) {
        let message = '發生了未知錯誤';
        if (error) {
          message = error.msg ? error.msg : error;
        }
        this.$message.error(message);
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomUid, fun: 'init' },
          error
        );
      }
    },
    async initIm() {
      try {
        // await VoiceRoomIM.login(this.userInfo);
        await VoiceRoomIM.IM_READY;
        await VoiceRoomIM.joinGroup(this.roomUid);
        await VoiceRoomIM.setUserId(this.uuid);
        return true;
      } catch (error) {
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomUid, fun: 'initIm' },
          error
        );
        throw new Error('加入语聊房错误');
      }
    },
    async initRtc() {
      try {
        const { data } = await getToken({ roomUid: this.roomUid });
        if (data) {
          this.subscribeAudio();
          await mRtc.join({
            appId: data.appId,
            channel: this.roomUid,
            token: data.token,
            uid: Number(this.uuid)
          });
          await mRtc.initTrack();
          await mRtc.ready();
          this.volumeIndicator();
          return true;
        }
      } catch (error) {
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomUid, fun: 'initRtc' },
          error
        );
        this.$message.error(
          '麥克風獲取失敗,請查看瀏覽器設置，確保已允許nicee使用你的麥克風'
        );
        // throw new Error(
        //   '麥克風獲取失敗,請查看瀏覽器設置，確保已允許nicee使用你的麥克風'
        // );
      }
    },

    async getRoomInfo() {
      try {
        const { data } = await getRoomInfo({ roomUid: this.roomUid });
        if (data) {
          if (data.black) {
            throw new Error('您已被管理員加入小黑屋，無法進入');
          }
          if (
            data.open ||
            data.createBy == this.uuid ||
            CurrentUserProvider.isAdmin
          ) {
            VoiceRoomProvider.setRoomInfo(data);
            CurrentUserProvider.setCreate(data.createBy == this.uuid);
            return data;
          } else {
            throw new Error('房間未開放');
          }
        } else {
          throw new Error('房間未開放');
        }
      } catch (error) {
        if (error && error.code == 9000) {
          this.$confirm({
            content: '你已被加入小黑屋，去其他厅玩吧',
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickModal: false
          }).then(() => {
            this.$router.push({ path: '/' });
          });
        }
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomUid, fun: 'getRoomInfo' },
          error
        );
        throw error;
      }
    },

    async joinRoom() {
      try {
        let params = {};
        params['roomUid'] = this.roomUid;
        params['action'] = 'JoinRoom';
        params['targetUuid'] = this.uuid;
        await joinRoom(params);
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 订阅音频
     * @return {*}
     */
    async subscribeAudio() {
      try {
        // 监听发布事件
        mRtc.client.on('user-published', async (user, mediaType) => {
          mRtc.subscribeRemoteUser(user, mediaType);
        });
        // 监听取消发布事件
        mRtc.client.on('user-unpublished', async user => {
          delete mRtc.remoteUsers[user.uid];
        });
      } catch (error) {
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomUid, fun: 'subscribeAudio' },
          error
        );
      }
    },

    /**
     * @description: 启用说话者音量提示。
     * @return {*}
     */
    volumeIndicator() {
      mRtc.enableAudioVolumeIndicator();
      mRtc.client.on('volume-indicator', volumes => {
        try {
          const seatList = this.seatList.filter(item => {
            return item.userUuid ? true : false;
          });
          volumes.forEach(volume => {
            const seat = seatList.find(item => {
              return item.userUuid == volume.uid;
            });
            if (seat) {
              if (volume.level && volume.level > 50) {
                Vue.set(seat, 'volume', volume.level);
                if (volume.uid === this.uuid) {
                  VoiceRoomEventEmitter.emit(
                    VoiceRoomEvent.refreshLastSpeakTime
                  );
                }
              } else {
                if (seat['volume']) {
                  Vue.set(seat, 'volume', 0);
                  delete seat['volume'];
                }
              }
            }
          });
        } catch (error) {
          this.$util.captureException(
            'voice-room',
            { roomUid: this.roomUid, fun: 'volumeIndicator' },
            error
          );
          console.log(error);
        }
      });
    },
    async leaveVoiceRoom() {
      try {
        if (this.keepConnectInterval) {
          clearInterval(this.keepConnectInterval);
          this.keepConnectInterval = null;
        }
        await mRtc.leave();
        VoiceRoomEventEmitter.removeAllListeners();
      } catch (error) {
        this.$util.captureException(
          'voice-room',
          { roomUid: this.roomUid, fun: 'leaveVoiceRoom' },
          error
        );
        throw error;
      }
    },

    // 获取用户是否是管理员
    async getUserAdmin() {
      const adminList = await VoiceRoomProvider.getAdminList(this.roomUid);
      if (adminList && adminList.find(item => item.uuid == this.uuid)) {
        CurrentUserProvider.setAdmin(true);
      } else {
        CurrentUserProvider.setAdmin(false);
      }
      return;
    },
    setScale() {
      const height = this.$refs.voiceRoomBox.offsetHeight;
      const width = this.$refs.voiceRoomBox.offsetWidth;
      const childHeight = this.$refs.voiceRoomMain.offsetHeight + 20;
      const childWidth = this.$refs.voiceRoomMain.offsetWidth + 20;
      let scale = 1;
      if (childWidth > width || childHeight > height) {
        const widthSize = width / childWidth;
        const heightSize = height / childHeight;
        if (widthSize < heightSize) {
          scale = widthSize;
        } else {
          scale = heightSize;
        }
        scale = scale + this.scale / 100;
        this.$refs.voiceRoomMain.style.transform = `scale(${scale})`;
        this.$refs.voiceRoomMain.style.transformOrigin = `50% 50%`;
      } else {
        this.$refs.voiceRoomMain.style.transform = `scale(${1 +
          this.scale / 100})`;
        // this.$refs.voiceRoomMain.style.transformOrigin = `0 0`;
        this.$refs.voiceRoomMain.style.transformOrigin = `50% 50%`;
      }
      localStorage.setItem('voiceRoomScale', this.scale);
    },
    keepConnect() {
      this.keepConnectInterval = setInterval(async () => {
        try {
          if (this.keepConnectLoading) {
            return;
          } else {
            this.keepConnectLoading = true;
            await keepConnect({ roomUid: this.roomUid });
            this.keepConnectLoading = false;
          }
        } catch (error) {
          this.keepConnectLoading = false;
        }
      }, 30000);
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    this.scale = Number(localStorage.getItem('voiceRoomScale') || 0);
    this.setScale();
  },
  destroyed() {
    this.leaveVoiceRoom();
  }
};
</script>
<style lang="scss" scoped>
.voice-room {
  font-family: Microsoft YaHei, PingFang TC, PingFang TC Medium, sans-serif;
  display: flex;
  align-items: center;
  width: 100% !important;
  overflow: auto;
  height: 100%;
  // height: 884px;
  @include hideScrollBar(0, 0);
  // transform: scale(0.8);
  position: relative;
  .right {
    flex: 1 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin: 0 20px;
    // padding: 20px 20px;
    // max-height: 836px;
    width: 1px;
    // height: 884px;
    @include hideScrollBar(0, 0);
  }
  .main {
    // margin: 0 auto;
    // width: 1188px;
    display: flex;
    align-items: stretch;
    height: 844px;
  }
  .chat-main {
    margin: 0 11px;
  }
  .rank-main {
    // margin-left: 11px;
    flex: none;
    width: 333px;
    display: flex;
    flex-direction: column;
    color: white;
    border-radius: 21px;
    // background: #222444;
    overflow: hidden;
    line-height: 1.6;
    overflow: hidden;
    /deep/ .el-tabs__item {
      padding: 0 18px !important;
      color: rgba(255, 255, 255, 0.33);
      &.is-active {
        color: white;
      }
    }
    /deep/ .el-tabs__nav-wrap {
      &::after {
        display: none;
      }
    }
  }
  .voice-room-main {
    margin: 0;
  }
  .room-info {
    flex: none;
  }
  .user-list {
    flex: auto;
  }
}
</style>
